export default "__VITE_ASSET__BkhNVJzb__"